<template>
    <div class="admin-container">
        <div class="layout-container">
            <aside class="sidebar ignore">
                <h2>篩選條件</h2>
                <div class="filter-row">
                    <div class="filter-group">
                        <label>商品種類:</label>
                        <select v-model="currentFilterCategory" @change="handleCategoryChange">
                            <option value="">所有種類</option>
                            <option v-for="category in AllKind" :key="category.value" :value="category.value">{{ category.label }}</option>
                        </select>
                    </div>
                    <div class="filter-group">
                        <label>適用性別:</label>
                        <select v-model="currentFilterGender">
                            <option value="">所有性別</option>
                            <option v-for="genderItem in Gender" :key="genderItem.value" :value="genderItem.value">{{ genderItem.label }}</option>
                        </select>
                    </div>
                    <div class="filter-group">
                        <label>品牌:</label>
                        <!-- <select v-model="currentFilterBrand" :disabled="!currentFilterCategory" @change="handleBrandChange"> -->
                        <select v-model="currentFilterBrand" @change="handleBrandChange">
                            <option value="">所有品牌</option>
                            <option v-for="brand in brands" :key="brand.BrandName" :value="brand.BrandName">{{ brand.BrandName }}</option>
                        </select>
                    </div>
                    <div class="filter-group">
                        <label>型號:</label>
                        <select v-model="currentFilterModel" :disabled="!currentFilterBrand">
                            <option value="">所有型號</option>
                            <option v-for="model in models" :key="model.id" :value="model.name">{{ model.name }}</option>
                        </select>
                    </div>
                    <div class="filter-group">
                        <label>狀態:</label>
                        <select v-model="currentFilterStatus">
                            <option value="">所有狀態</option>
                            <option value="on">上架中</option>
                            <option value="off">已下架</option>
                        </select>
                    </div>
                </div>
            </aside>

            <div class="main-content">
                <section class="controls-section">
                    <label>搜尋名稱/ID:</label>
                    <div class="search-action-row">
                        <div class="search-group">
                            <input type="text" v-model="currentSearchTerm" placeholder="輸入關鍵詞...">
                        </div>
                        <button class="btn btn-search" @click="applySearchAndFilter">應用查詢條件</button>
                        <button class="btn btn-reset" @click="resetFilters">重設</button>
                    </div>
                </section>

                <section class="product-list-section">
                    <div class="product-list-header">
                        <h2>商品列表</h2>
                        <button class="btn btn-add" @click="openAddModal">新增商品</button>
                    </div>
                    <div class="table-wrapper">
                        <table class="product-table">
                            <thead>
                                <tr>
                                    <th style="width: 1%"><input type="checkbox" :checked="allSelected" :disabled="productItems.length === 0" @change="toggleSelectAll"></th>
                                    <th>商品ID</th>
                                    <th>商品名稱</th>
                                    <th>目前價格 (元)</th>
                                    <th>狀態</th>
                                    <th>主圖</th>
                                    <th>標籤</th>
                                    <th style="width: 120px;">操作</th> <!-- 調整寬度以適應圖標按鈕 -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="loadingOverlayVisible && productItems.length === 0">
                                    <td colspan="8" class="loading-placeholder">正在載入商品數據...</td>
                                </tr>
                                <tr v-else-if="productItems.length === 0">
                                    <td colspan="8" class="no-data">沒有找到符合條件的商品。</td>
                                </tr>
                                <tr v-for="product in productItems" :key="product.id" :class="{ selected: selectedProductIds.has(product.id) }">
                                    <td><input type="checkbox" :value="product.id" :checked="selectedProductIds.has(product.id)" @change="handleRowSelectionChange"></td>
                                    <td>{{ product.id }}</td>
                                    <td>{{ product.GoodsName }}</td>
                                    <td>{{ product.price.toFixed(2) }}</td>
                                    <td :class="['status-' + product.status]">{{ product.status === 'on' ? '上架中' : '已下架' }}</td>
                                    <td><img :src="`${backendBaseUrl}/${product.mainImage}`"  alt="主圖" class="thumbnail"></td>
                                    <td>{{ product.tags.join(', ') || '無標籤' }}</td>
                                    <td>
                                        <div class="action-buttons">
                                            <button class="btn btn-icon btn-view-details" @click="openDetailsModal(product)" title="查看詳情">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zm-1-2V4H5v16h14zM7 6h4v2H7V6zm0 4h10v2H7v-2zm0 4h10v2H7v-2z"/></svg>
                                            </button>
                                            <button class="btn btn-icon btn-edit" @click="openEditModal(product)" title="編輯">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M16.707 4.293a1 1 0 0 0-1.414 0L6 13.586V18h4.414l9.293-9.293a1 1 0 0 0 0-1.414l-3-3zM8 16v-2.586L13.586 8 16 10.414 10.414 16H8zM18.5 7.086l-3-3L16.207 3.5a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414L18.5 7.086zM5 22a1 1 0 0 1-1-1V7a1 1 0 0 1 2 0v13a1 1 0 0 0 1 1h11a1 1 0 0 1 0 2H5z"/></svg>
                                            </button>
                                            <button class="btn btn-icon btn-delete" @click="handleDeleteProduct(product)" title="刪除">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M7 21a1 1 0 0 1-1-1V7H4a1 1 0 0 1 0-2h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h4a1 1 0 0 1 0 2h-2v13a1 1 0 0 1-1 1H7zm2-11v8h2v-8H9zm4 0v8h2v-8h-2zm-6-5h8V4h-8v2z"/></svg>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination">
                        <button class="btn page-btn prev" :disabled="currentPage <= 1" @click="goToPage(currentPage - 1)">上一頁</button>
                        <div class="page-number-buttons">
                            <template v-for="page in paginationPages" :key="page.number">
                                <button v-if="page.type === 'number'" :class="['btn', 'page-btn', { active: page.number === currentPage }]" @click="goToPage(page.number)">{{ page.number }}</button>
                                <span v-else>...</span>
                            </template>
                        </div>
                        <button class="btn page-btn next" :disabled="currentPage >= totalPages" @click="goToPage(currentPage + 1)">下一頁</button>
                        <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 頁 (共 {{ totalItems }} 條)</span>
                        <select v-model="itemsPerPage" @change="changeItemsPerPage">
                            <option value="10">10條/頁</option>
                            <option value="20">20條/頁</option>
                            <option value="50">50條/頁</option>
                            <option value="100">100條/頁</option>
                        </select>
                    </div>
                </section>
            </div>
        </div>

        <div id="loading-overlay" v-show="loadingOverlayVisible">
            <div class="spinner"></div>
        </div>

        <!-- 模態框組件 -->
        <AddProductModal
            :is-visible="isAddModalVisible"
            @close="closeAddModal"
            @save="handleAddProduct"
        />
        <EditProductModal
            :is-visible="isEditModalVisible"
            :product="productToEdit"
            @close="closeEditModal"
            @save="handleUpdateProduct"
        />

    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddProductModal from './component/AddProductModal.vue';
import EditProductModal from './component/EditProductModal.vue';
import shopServer from  '../../services/shopManages.js';
import { useRouter } from 'vue-router';

const router = useRouter();

const currentPage = ref(1);
const itemsPerPage = ref(20);
const currentSearchTerm = ref('');
const currentFilterCategory = ref('');
const currentFilterGender = ref('');
const currentFilterBrand = ref('');
const currentFilterModel = ref('');
const currentFilterStatus = ref('');
const currentSortColumn = ref('id');
const totalItems = ref(0);
const totalPages = ref(1);
const productItems = ref([]);
const selectedProductIds = ref(new Set());
const brands = ref([]);
const models = ref([]);
const loadingOverlayVisible = ref(false);

const isAddModalVisible = ref(false);
const isEditModalVisible = ref(false);
const productToEdit = ref(null);

const backendBaseUrl = process.env.VUE_APP_BACKEND_BASE_URL;

const AllKind = [
  { label: '水槽&洗碗槽', value: 'sink_and_dishwasher' },
  { label: '花架&花盆', value: 'flower_stand_and_pot' },
  { label: '床頭靠墊/床頭軟包', value: 'bed_head_cushion' },
  { label: '山水畫', value: 'landscape_painting' },
  { label: '塌塌米豆帶沙發', value: 'tatami_sofa' },
  { label: '長凳子/長條椅', value: 'bench' },
  { label: '角鋼架/貨架', value: 'steel_shelf' },
  { label: '貓爬架/貓窩/貓屋', value: 'cat_tree_and_house' },
  { label: '戶外沙發', value: 'outdoor_sofa' },
  { label: '人台/服裝模特', value: 'mannequin' },
  { label: '蚊帳', value: 'mosquito_net' },
  { label: '健身器材', value: 'fitness_equipment' },
  { label: '衣櫥/衣櫃/衣架', value: 'wardrobe_and_rack' },
  { label: '鏡櫃', value: 'mirror_cabinet' },
  { label: '沙發/電腦椅/長椅', value: 'sofa_and_chair' },
  { label: '汽車配件', value: 'automotive_parts' },
];

const Gender = [
  {label: '男士',value: 'men'},
  {label: '女士',value:'female'},
  {label: '情侶',value:'neutral'}
];

// 打開添加框
const openAddModal = () => {
    isAddModalVisible.value = true;
};

// 關閉添加框
const closeAddModal = () => {
    isAddModalVisible.value = false;
};

// 添加新商品
const handleAddProduct = async (newProductData) => {
    const formData = new FormData()
        // 添加基礎字段
        formData.append('name', newProductData.name)
        formData.append('brandName', newProductData.brandName)
        formData.append('model', newProductData.model)
        formData.append('price', newProductData.price)
        formData.append('normal_price', newProductData.normal_price)
        formData.append('description', newProductData.description)
        formData.append('status', newProductData.status)
        formData.append('gender', newProductData.gender)
        formData.append('mainImage', newProductData.mainImage)
        formData.append('kind', newProductData.kind)
        // 轉換複雜結構為JSON
        formData.append('shoeSizes', JSON.stringify(newProductData.shoeSizes))
        formData.append('tags', JSON.stringify(newProductData.tags))
        
        // 添加圖片文件（確保字段名與後端一致）
        newProductData.imageFiles.forEach((img, index) => {
                formData.append(
                    'imageFiles',
                    img, // file 本身就是 File 類型
                )
        })
        try{
            await shopServer.AddGoods(formData);
            closeAddModal(); 
        }catch(error){
            ElMessage.error(`添加商品失敗: ${error.response.data.detail}`);
        }
    closeAddModal();
    await GetProductData();
    fetchProductData();
};

// 打開編輯框
const openEditModal = (product) => {
    productToEdit.value = product;
    isEditModalVisible.value = true;
};

// 關閉編輯框
const closeEditModal = () => {
    isEditModalVisible.value = false;
    productToEdit.value = null;
};

// 更新商品
const handleUpdateProduct = async (updatedProductData) => {
    try{
        const formData = new FormData()
            // 添加基礎字段
            formData.append('id', updatedProductData.id)
            formData.append('name', updatedProductData.GoodsName)
            formData.append('brandName', updatedProductData.brandName)
            formData.append('model', updatedProductData.model)
            formData.append('price', updatedProductData.price)
            formData.append('normal_price', updatedProductData.normal_price)
            formData.append('description', updatedProductData.description)
            formData.append('status', updatedProductData.status)
            formData.append('gender', updatedProductData.gender)
            formData.append('mainImage', updatedProductData.mainImage)
            formData.append('kind', updatedProductData.kind)
            // 轉換複雜結構為JSON
            formData.append('shoeSizes', JSON.stringify(updatedProductData.shoeSizes))
            formData.append('tags', JSON.stringify(updatedProductData.tags))
            
            // 添加圖片文件（確保字段名與後端一致）
            formData.append("deletedImageUrls", updatedProductData.deletedImageUrls)
            updatedProductData.newImageFiles.forEach((img, index) => {
                    formData.append(
                        'imageFiles',
                        img, // file 本身就是 File 類型
                    )
            })
            try{
                await shopServer.UpdateGoods(formData);
            }catch(error){
                ElMessage.error(`更新商品失敗: ${error.response.data.detail}`);
            }
        closeEditModal();
        await GetProductData();
        fetchProductData();
    }catch(error){
        ElMessage.error(`更新商品失敗: ${error.message}`); 
    }
};

// 查看商品詳情
const openDetailsModal = (product) => {
    const routeData = router.resolve({
        name: 'ShoeDetail',
        params: { id: product.id }
    })
    window.open(routeData.href, '_blank')
};

// 刪除商品
const handleDeleteProduct = async (product) => {
    try{

        await ElMessageBox.confirm(
            `確定要刪除商品 "${product.GoodsName}" (ID: ${product.id}) 嗎？此操作無法撤銷。`, // 提示內容
            '確認刪除', // 標題
            {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning', // 彈窗類型，例如 warning, success, info, error
            }
        );
        await shopServer.DelGoods(product.id);
        ElMessage.success(`商品 "${product.GoodsName}" (ID: ${product.id}) 已成功刪除。`);
        await GetProductData();
        fetchProductData();
    }catch(error){
        ElMessage.error(`刪除商品失敗`);
    }
};

// 判斷商品是否都被選中
const allSelected = computed(() => productItems.value.length > 0 && productItems.value.every(product => selectedProductIds.value.has(product.id)));

// 處理分頁
const paginationPages = computed(() => {
    const pages = [];
    const maxPagesToShow = 5; 
    const halfMax = Math.floor(maxPagesToShow / 2);

    if (totalPages.value <= maxPagesToShow) {
        for (let i = 1; i <= totalPages.value; i++) {
            pages.push({ type: 'number', number: i });
        }
    } else {
        pages.push({ type: 'number', number: 1 });
        let startPage = Math.max(2, currentPage.value - halfMax + (maxPagesToShow % 2 === 0 ? 1: 0) );
        let endPage = Math.min(totalPages.value - 1, currentPage.value + halfMax);
        if (currentPage.value <= halfMax +1) {
             endPage = Math.min(totalPages.value - 1, maxPagesToShow-2);
        }
        if (currentPage.value >= totalPages.value - halfMax) {
            startPage = Math.max(2, totalPages.value - maxPagesToShow + 3);
        }
        if (startPage > 2) {
            pages.push({ type: 'ellipsis' });
        }
        for (let i = startPage; i <= endPage; i++) {
            pages.push({ type: 'number', number: i });
        }
        if (endPage < totalPages.value - 1) {
            pages.push({ type: 'ellipsis' });
        }
        pages.push({ type: 'number', number: totalPages.value });
    }
    return pages.filter((page, index, self) => 
        index === self.findIndex((p) => (
           p.type === page.type && p.number === page.number
        ))
    );
});

// 獲取品牌數據
async function GetBrandData() {
    try{
        brands.value = await shopServer.GetGoodsType();
    }catch(error){
       ElMessage.error(error)
    }
}

// 獲取商品數據
let allProduct = []
async function GetProductData() {
    try{
        allProduct = await shopServer.GetGoods()
    }catch(error){
       ElMessage.error(error) 
    }
}

// 篩選獲取商品數據
async function fetchProductData() {
    loadingOverlayVisible.value = true;
    setTimeout(() => {
        let filteredProducts = [...allProduct];
        if (currentFilterCategory.value) {
            filteredProducts = filteredProducts.filter(p => p.kindName  === currentFilterCategory.value);
        }
        if (currentFilterGender.value) {
            filteredProducts = filteredProducts.filter(p => p.gender === currentFilterGender.value);
        }
        if (currentFilterBrand.value) { 
            const brandObj = brands.value.find(b => b.BrandName === currentFilterBrand.value);
            if (brandObj) filteredProducts = filteredProducts.filter(p => p.brandName === brandObj.BrandName); 
        }
        if (currentFilterModel.value) { 
            const modelObj = models.value.find(m => m.id === currentFilterModel.value);
            if (modelObj) filteredProducts = filteredProducts.filter(p => p.model === modelObj.name); 
        }
        if (currentFilterStatus.value) {
            filteredProducts = filteredProducts.filter(p => p.status === currentFilterStatus.value);
        }
        if (currentSearchTerm.value) {
            const term = currentSearchTerm.value.toLowerCase();
            filteredProducts = filteredProducts.filter(p => {
                // 確保 GoodsName 存在且是字符串再調用 toLowerCase
                const nameMatch = p.GoodsName && typeof p.GoodsName === 'string' && p.GoodsName.toLowerCase().includes(term);
                // 確保 id 存在且是字符串再調用 toLowerCase (如果 id 可能是數字，先轉為字符串)
                const idMatch = p.id && String(p.id).toLowerCase().includes(term);
                return nameMatch || idMatch;
            });
        }

        if (currentSortColumn.value) {
            filteredProducts.sort((a, b) => {
                let valA = a[currentSortColumn.value];
                let valB = b[currentSortColumn.value];
                if (typeof valA === 'string') valA = valA.toLowerCase();
                if (typeof valB === 'string') valB = valB.toLowerCase();
                if (valA < valB) return -1;
                if (valA > valB) return 1;
                return 0;
            });
        }

        totalItems.value = filteredProducts.length;
        totalPages.value = Math.ceil(totalItems.value / Number(itemsPerPage.value));
        if (currentPage.value > totalPages.value && totalPages.value > 0) {
            currentPage.value = totalPages.value; 
        } else if (totalPages.value === 0 && totalItems.value === 0) {
             currentPage.value = 1;
        }

        const start = (currentPage.value - 1) * Number(itemsPerPage.value);
        const end = start + Number(itemsPerPage.value);
        productItems.value = filteredProducts.slice(start, end);

        selectedProductIds.value.clear(); 
        loadingOverlayVisible.value = false;
    }, 300);
}


onMounted(async () => {
    // generateAllMockProducts(); 
    // categories.value = mockCategories;
    await GetProductData();
    await GetBrandData();
    resetFilters()
});

// 應用搜尋和篩選條件
function applySearchAndFilter() {
    currentPage.value = 1;
    fetchProductData();
}

// 重設篩選條件
function resetFilters() {
    currentSearchTerm.value = '';
    currentFilterCategory.value = '';
    currentFilterBrand.value = '';
    brands.value = [];
    currentFilterGender.value = '';
    currentFilterModel.value = '';
    models.value = [];
    currentFilterStatus.value = '';
    currentSortColumn.value = 'id'; 
    currentPage.value = 1;
    fetchProductData();
}

// 處理分類篩選
function handleCategoryChange() {
    currentFilterBrand.value = '';
    currentFilterModel.value = '';
    models.value = []; 
    if (currentFilterCategory.value) {
        const categoryProducts = allProduct.filter(p => p.kindName === currentFilterCategory.value);
        const uniqueBrands = [...new Set(categoryProducts.map(p => p.brandName))];
        brands.value = uniqueBrands.map(name => ({ BrandName: name }));
    } else {
        GetBrandData();
    }
}


// 處理品牌篩選
function handleBrandChange() {
    currentFilterModel.value = '';
    if (currentFilterBrand.value) {
        // 篩選時，最好同時考慮已選的分類和性別（如果商品數據中有這些字段）
        let filteredProductsForModel = allProduct.filter(p => p.brandName === currentFilterBrand.value);

        if (currentFilterCategory.value) {
            filteredProductsForModel = filteredProductsForModel.filter(p => p.kindName === currentFilterCategory.value);
        }
        if (currentFilterGender.value) {
            // 假設商品對象有 gender 字段，值為 'men' 或 'female'
            filteredProductsForModel = filteredProductsForModel.filter(p => p.gender === currentFilterGender.value);
        }
        const uniqueModels = [...new Set(filteredProductsForModel.map(p => p.model).filter(Boolean))];
        models.value = uniqueModels.map(modelName => ({ name: modelName })); // 假設 model 對象結構是 { name: 'xxx' }
    } else {
        models.value = [];
    }
}

// 處理全選/取消全選
function toggleSelectAll(event) {
    if (event.target.checked) {
        productItems.value.forEach(product => selectedProductIds.value.add(product.id));
    } else {
        selectedProductIds.value.clear();
    }
}

// 處理行選擇
function handleRowSelectionChange(event) {
    const productId = event.target.value; 
    if (event.target.checked) {
        selectedProductIds.value.add(productId);
    } else {
        selectedProductIds.value.delete(productId);
    }
}

function goToPage(page) {
    if (page >= 1 && page <= totalPages.value && page !== currentPage.value) {
        currentPage.value = page;
        fetchProductData();
    }
}

function changeItemsPerPage() {
    currentPage.value = 1;
    fetchProductData();
}
</script>

<style scoped>
/* ... (大部分样式与上一版本相同，这里不再重复) ... */
/* 来自你原始组件的样式 */
/* 搜索和控制区域 */
.controls-section {
    background-color: #f0f0f0;
    padding: 18px;
    border-radius: 8px;
    margin-bottom: 20px;
}
.controls-section > label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

/* 侧边栏 */
.sidebar {
    width: 250px;
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    align-self: flex-start;
    height: fit-content; 
}
.sidebar h2 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 1.2em;
}

/* 分页 */
.pagination {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap; 
}
.page-btn {
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    padding: 8px 12px;
}
.page-btn.prev, .page-btn.next {
    padding: 8px 16px;
}
.page-btn.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}
.page-info {
    margin-left: 8px;
    font-size: 14px;
    white-space: nowrap;
}
.pagination select {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ddd;
    background-color: white;
}
.page-number-buttons {
    display: flex;
    gap: 5px;
}
.page-number-buttons span {
    padding: 8px 0;
    align-self: center;
    color: #6c757d;
}

/* 表单和输入框 */
.filter-group select,
.search-group input[type="text"] {
    width: 100%; 
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background-color: #fff;
    box-sizing: border-box;
}
.search-group input[type="text"] {
    min-width: 200px; 
}


/* 按钮 */
.btn-search {
    background-color: #007bff;
    color: white;
}
.btn-reset {
    background-color: #6c757d;
    color: white;
    min-width: 80px;
}
.btn-add {
    background-color: #28a745;
    color: white;
}

/* 布局 */
body { 
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    margin: 0;
    padding: 0; 
    background-color: #e9ecef;
}
.admin-container {
    background-color: white;
    padding: 20px;
    border-radius: 8px; 
}
.layout-container {
    display: flex;
    gap: 20px;
}
.main-content {
    flex: 1;
    min-width: 0;
}
.search-action-row {
    display: flex;
    align-items: center;
    gap: 10px; 
    flex-wrap: wrap; 
}
.search-group {
    flex: 1 1 auto; 
}

/* 表单组 (侧边栏) */
.filter-group {
    margin-bottom: 15px;
}
.filter-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 0.9em;
    color: #495057;
}

/* 通用按钮样式 */
.btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}
.btn:hover:not(:disabled) {
    opacity: 0.85;
}

/* 状态指示器 */
.status-on { color: #28a745; font-weight: 500; }
.status-off { color: #dc3545; font-weight: 500; }

/* 商品列表头部 */
.product-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}
.product-list-header h2 {
    margin: 0;
    font-size: 1.4em;
}

/* 表格样式 */
.table-wrapper {
    overflow-x: auto;
}
.product-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9em;
}
.product-table th,
.product-table td {
    padding: 10px 12px; 
    border: 1px solid #dee2e6; 
    text-align: center; 
    vertical-align: middle;
}

.product-table th:first-child, .product-table td:first-child, 
.product-table th:nth-child(2), .product-table td:nth-child(2)
{
    text-align: center;
}
.product-table th:nth-child(3), .product-table td:nth-child(3) {
    text-align: center;
}


.product-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    white-space: nowrap; 
}

.product-table tr:hover:not(.selected) { 
    background-color: #f1f3f5;
}
.product-table tr.selected {
    background-color: #cfe2ff4b; 
}

.thumbnail {
    max-width: 50px;
    max-height: 50px;
    border-radius: 4px;
    object-fit: cover;
    border: 1px solid #ddd;
    display: block; 
    margin: auto; 
}

.no-data, .loading-placeholder {
    text-align: center;
    padding: 30px 20px; 
    color: #6c757d;
    font-style: italic;
    font-size: 1.1em;
}

#loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000; 
}
.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* --- 操作按钮样式（大部分与上一版相同，新增.btn-icon） --- */
.action-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.btn-small { /* 这个类现在可能不需要了，因为图标按钮有自己的大小控制 */
    /* padding: 4px 8px; */
    /* font-size: 13px; */
}

/* 新增：用于图标按钮的特定样式 */
.btn-icon {
    padding: 6px; /* 给图标按钮一个合适的内边距 */
    line-height: 1; /* 确保图标垂直居中 */
    min-width: 30px; /* 给按钮一个最小宽度，使其看起来像个方形或圆形 */
    height: 30px;   /* 高度与宽度一致 */
    display: inline-flex; /* 使内部SVG能更好地对齐 */
    justify-content: center;
    align-items: center;
}
.btn-icon svg {
    /* SVG 默认会继承按钮的 color, 但如果 SVG 内有自己的 fill, 需要设置为 currentColor */
    /* width 和 height 已在 SVG 标签中设置，这里可以不用重复，除非要覆盖 */
}


.btn-view-details {
    background-color: #17a2b8; 
    color: white;
    border: 1px solid #17a2b8;
}
.btn-view-details:hover {
    background-color: #138496;
    border-color: #117a8b;
}

.btn-edit { 
    background-color: #ffc107;
    color: #212529;
    border: 1px solid #ffc107;
}
.btn-edit:hover {
    background-color: #e0a800;
    border-color: #d39e00;
}

.btn-delete {
    background-color: #dc3545; 
    color: white;
    border: 1px solid #dc3545;
}
.btn-delete:hover {
    background-color: #c82333;
    border-color: #bd2130;
}
</style>
